<template>
  <div>
    <el-form ref="formData" :model="formData" size="small">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.proofing_label_proofingType') || '打样类型'"
          >
            <el-input v-model="formData.v_proofingType" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.proofing_label_demandTime') || '需求时间'"
          >
            <el-input v-model="formData.demandTime" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('INDEX.proofing_label_qty') || '需求数量'">
            <el-input v-model="formData.qty" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.proofing_label_sampleUse') || '样品用途'"
          >
            <el-input
              v-model="formData.sampleUse"
              type="textarea"
              rows="3"
              maxlength="1000"
              show-word-limit
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.proofing_label_proofingRequirement') || '交付要求'
            "
          >
            <el-input
              v-model="formData.proofingRequirement"
              type="textarea"
              rows="3"
              maxlength="1000"
              show-word-limit
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.proofing_label_photoRequirement') || '拍摄要求'"
          >
            <el-input
              v-model="formData.photoRequirement"
              type="textarea"
              rows="3"
              maxlength="1000"
              show-word-limit
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <GoodsTable class="mt-2" :orderProofingCode="orderProofingCode" />
      </el-row>
    </el-form>
  </div>
</template>

<script>
import GoodsTable from '../goods-table'
export default {
  components: { GoodsTable },
  props: {
    orderProofingCode: { type: String, default: '' },
  },
  data() {
    return {
      proofingTypeParams: { dictType: 'proofingType' },
      formData: {},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderProofingCode) return
      this.$api
        .pendingOrderProofingDetailApi({
          orderProofingCode: this.orderProofingCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
  },
}
</script>
